// extracted by mini-css-extract-plugin
export var deliveryRow = "_nv-a";
export var fixedHeight = "_nv-4";
export var freightLogo = "_nv-9";
export var fullWidth = "_nv-3";
export var priceColumn = "_nv-5";
export var radioSelected = "_nv-7";
export var radioUnselected = "_nv-6";
export var selectedOption = "_nv-2";
export var selectedOptionContainer = "_nv-1";
export var selection = "_nv-0";
export var tallSkeletonText = "_nv-8";